import { Component } from '@angular/core';

import { DsBadge, DsBadgeVariant } from '@frontend/ui/badge';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    selector: 'ms-prize-boost-badge',
    templateUrl: 'prize-boost-badge.component.html',
    imports: [DsBadge, IconCustomComponent],
    standalone: true,
})
export class PrizeBoostBadgeComponent {
    readonly badgeVariant: DsBadgeVariant = 'yellow';
}
